import { useState, useCallback, useEffect, useRef } from "react";
import { useAuthenticatedFetchWithWorkspace } from "../../Keycloak/useAuthenticatedFetchWithWorkspace";
import { DefaultTimeslots } from "../../../pages/Marketing/Timeslots/types";

const useGetDefaultTimeslots = () => {
    const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>("");
    const [data, setData] = useState<DefaultTimeslots | null>(null);

    const getDefaultTimeslots = useCallback(async (): Promise<DefaultTimeslots | null> => {
        setLoading(true);
        setError("");
        try {
            const result: DefaultTimeslots = await authFetch("/getDefaultTimeslots", {
                method: "GET",
            });
            setData(result);
            return result;
        } catch (err: unknown) {
            setError(err instanceof Error ? err.message : "An unknown error occurred");
            return null;
        } finally {
            setLoading(false);
        }
    }, [authFetch]);

    const getDefaultTimeslotsRef = useRef(getDefaultTimeslots);
    getDefaultTimeslotsRef.current = getDefaultTimeslots;

    useEffect(() => {
        if (!isReady) return;
        getDefaultTimeslotsRef.current();
    }, [isReady]);

    return { getDefaultTimeslots, loading, error, data };
};

export default useGetDefaultTimeslots;
